import { createSelector } from 'reselect';

const selectCount = (state) => state.notification;

export const selectNotificationCount = createSelector([selectCount], (notification) => notification.count);
export const selectNotificationDiscussion = createSelector([selectCount], (notification) => notification.discussion);
export const selectNotificationHighlights = createSelector([selectCount], (notification) => notification.highlights);
export const selectNotificationHelpChat = createSelector([selectCount], (notification) => notification.helpChat);
